(function() {
    'use strict';
    
a3_cabin_reports.controller('FirstAidKitCtrl', FirstAidKitCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name FirstAidKitCtrl
    * @description 
    *  Manages the First Aid Kit Modal View
    * @ngInject
    */
function FirstAidKitCtrl($scope, $uibModalInstance, ModalDialogResultFactory, FirstAidKitFactory, fak,IsEMK) {

		var result = ModalDialogResultFactory.createNew();
        console.log("emk " + IsEMK);
		if (fak == null) {
			result.Object = FirstAidKitFactory.createNew();
            result.Object.IsEMK = IsEMK;
			result.isInsertMode = true;
		} else {
			result.Object = FirstAidKitFactory.fromObject(fak);
			result.isInsertMode = false;
		}

		$scope.fak = result.Object;
        $scope.IsEMK = IsEMK;
    
		$scope.ok = ok;
        $scope.cancel = cancel;
        
        /**
         * Close modal after u check position
         * @memberof FirstAidKitCtrl
         */
        function ok() {
			if ((result.Object.Position == null) || (result.Object.Position == ''))
				result.Object.Position = '-';
			$uibModalInstance.close(result);
		}

        /**
         * Close Modal
         * @memberof FirstAidKitCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}

	}

})();
